export class ProductionProcessDashboardReq{
    date?: any
    startDate? :any;
    endDate? :any
    constructor(date?:any,startDate? :any,endDate? :any){
        this.date = date
        this.startDate=startDate
        this.endDate=endDate
    }
}